import { Component, ViewChild } from '@angular/core';

import { DataNewUser } from '../interface/add-user.interface';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { BreakpointObserver } from '@angular/cdk/layout';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalAddComponent } from '../modal-add/modal-add.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-deleted-users',
  templateUrl: './deleted-users.component.html',
  styleUrls: ['./deleted-users.component.scss']
})
export class DeletedUsersComponent {
  
  displayedColumns = ['name', 'rut', 'progress', 'color'];
  dataSource: MatTableDataSource<DataNewUser>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator =
    Object.create(null);
  @ViewChild(MatSort, { static: true }) sort: MatSort = Object.create(null);

  ngOnInit(): void {}

  constructor(
    public breakpointObserver: BreakpointObserver,
    private auth: AuthService,
    private dialog: MatDialog
  ) {
    breakpointObserver.observe(['(max-width: 600px)']).subscribe((result) => {
      this.displayedColumns = result.matches
        ? ['email', 'name', 'rol', 'rut']
        : ['email', 'name', 'rol', 'rut'];
    });

    this.dataSource = new MatTableDataSource();
  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openHeaderDialog() {
    const dialogRef = this.dialog.open(ModalAddComponent);
    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  delete() {
    Swal.fire({
      title: 'Deseas Eliminar a este usuario?',
      showDenyButton: true,
      showCancelButton: true,
      denyButtonText: `Eliminar`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        Swal.fire('Saved!', '', 'success');
      } else if (result.isDenied) {
        Swal.fire('Changes are not saved', '', 'info');
      }
    });
  }
}
